import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import PrizeSchemeService from '../../domain/PrizeSchemeService';
import gs from '../../styles/style';
import Breadcrumbs from '../Common/Breadcrumbs';
import { useForm } from '../Common/Form';
import PrizeSchemeForm from './PrizeSchemeForm';
var AddPrizeSchemeForm = function (_a) {
    var history = _a.history;
    var t = useTranslation()[0];
    var form = useForm({
        values: {
            prizes: [
                {
                    matches: []
                }
            ]
        },
        onSubmit: function (data) { return PrizeSchemeService.addPrizeScheme(data); },
        onSuccess: function (prizeScheme) { return history.push("/prize-schemes/".concat(prizeScheme.id)); }
    });
    return React.createElement("div", null,
        React.createElement(Breadcrumbs, null,
            React.createElement(Link, { to: "/prize-schemes" }, t('prize_schemes'))),
        React.createElement("div", { className: gs('section-header') },
            React.createElement("h1", { className: gs('section-title') }, t('add_prize_scheme'))),
        React.createElement(PrizeSchemeForm, { form: form }));
};
export default withRouter(AddPrizeSchemeForm);
